export default __webpack_public_path__ + "static/media/property_476.1505d748.png";